import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DashboardMenu from "./DashboardMenu";
import { useSelector } from "react-redux";

import styles from "./styles.module.scss";

const DashboardLayout = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("global");

  const currentUser = useSelector((state) => state.auth.currentUser); // Assuming user data is stored in Redux

  return (
    <div className={`${styles.dashboardLayout} pageContainer`}>
      <div className={styles.menuHolder}>
        <div className={styles.header}>
          <a href="/" className={styles.logoLink} />
        </div>

        <div
          className={styles.name}
          onClick={() => navigate("/dashboard/home")}
        >
          <span>{t("dashboard.welcome")}</span>
          <br />
          <span>
            {currentUser?.first_name} {currentUser?.last_name}
          </span>
        </div>
        <DashboardMenu />
      </div>
      <div className={styles.dashboardContent}>
        <Outlet />
      </div>
    </div>
  );
};

export default DashboardLayout;
